import { render, staticRenderFns } from "./ResearchBarPlot.vue?vue&type=template&id=7ca91ac1&"
import script from "./ResearchBarPlot.vue?vue&type=script&lang=js&"
export * from "./ResearchBarPlot.vue?vue&type=script&lang=js&"
import style0 from "./ResearchBarPlot.vue?vue&type=style&index=0&id=7ca91ac1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ca91ac1')) {
      api.createRecord('7ca91ac1', component.options)
    } else {
      api.reload('7ca91ac1', component.options)
    }
    module.hot.accept("./ResearchBarPlot.vue?vue&type=template&id=7ca91ac1&", function () {
      api.rerender('7ca91ac1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchBarPlot.vue"
export default component.exports